import { useDate } from '@customHooks/use-date';
import { RootState } from '@redux/store';
import { Footer } from "@fc/devteam-components-library";
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import PageWrapperI from '../../interfaces/page-wrapperI';
import homelinkfooter from '../links/homelinkfooter';
const PageWrapper = (props: PageWrapperI) => {
    const [date] = useDate();
    const { t } = useTranslation(['common']);
    const session = useSelector((state: RootState) => state.session);

    return (
        <div
            className={
                session.username !== null
                    ? 'PageContainerDashboard'
                    : 'PageContainer'
            }
        >
            <div className="PageHeaderContainer">{props.header}</div>
            {props.menuComponent ? props.menuComponent : null}
            <div className={props.bodyClass ? props.bodyClass : 'Body'}>
                {props.previousPageButton ? (
                    <div className="BtnBack__Ctr">
                        <div className="BtnBack__Ctr">
                            {props.previousPageButton}
                        </div>
                    </div>
                ) : null}
                {props.children}
            </div>
            {!props.hideFooter ? (
                <div className="PageFooterContainer">
                    <Footer
                        homelinkfooter={homelinkfooter}
                        footerCopyText={`© ${date.year} Dr Prox. ${t('copy')}`}
                    />
                </div>
            ) : null}
        </div>
    );
};

export default PageWrapper;
